module.exports = __webpack_public_path__ + "static/media/16.30a8108c.svg";